<template>
  <v-dialog
    width="500px"
    :value="value"
    persistent
  >
    <v-card>
      <v-card-title
        class="confirmHeader font-weight-bold"
        :style="confirmHeaderColor"
      >
        {{ $t('dialogs.confirm.title') }}
      </v-card-title>

      <v-card-text class="mt-1 pb-3 pt-2 subtitle-2 font-weight-bold">
        {{ message }}
      </v-card-text>

      <v-divider/>
      <v-card-actions>
        <v-spacer/>
        <v-btn outlined :color="color" @click="cancelOperation()">{{ cancelText }}</v-btn>
        <v-btn dark :color="color" @click="confirmOperation()">{{ confirmText }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import i18n from '@/plugins/i18n';

export default {
  props: {
    value: Boolean,
    message: String,
    color: {
      type: String,
      default: 'primary',
    },
    confirmText: {
      type: String,
      default: i18n.t('actions.continue'),
    },
    cancelText: {
      type: String,
      default: i18n.t('actions.cancel'),
    },
  },

  computed: {
    confirmHeaderColor() {
      return `background-color: var(--v-${this.color}-base);`;
    },
  },

  methods: {
    cancelOperation() {
      this.$emit('cancel-operation');
    },

    confirmOperation() {
      this.$emit('confirm-operation');
    },
  },
};
</script>

<style scoped>
.confirmHeader {
  color: white;
}
</style>
